






import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { MobileGetter } from 'frontend/types';

@Component({
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class Landing extends Vue {
  private isMobile!: MobileGetter;
}
